import { render, staticRenderFns } from "./GovTecPage.vue?vue&type=template&id=5d936c72&scoped=true"
import script from "./GovTecPage.vue?vue&type=script&lang=js"
export * from "./GovTecPage.vue?vue&type=script&lang=js"
import style0 from "./GovTecPage.vue?vue&type=style&index=0&id=5d936c72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d936c72",
  null
  
)

export default component.exports